import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const VintageFilmOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;

  return (
          <div
            style={{
              width: "100%",
              padding: "52px 36px",
              background: "rgba(26,18,8,0.92)",
              borderTop: "2px solid rgba(212,168,83,0.5)",
              borderBottom: "2px solid rgba(212,168,83,0.5)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "24px",
            }}
          >
            <div
              style={{
                fontFamily: "'Special Elite', cursive",
                fontSize: "11px",
                color: "#8b6914",
                letterSpacing: "4px",
                textTransform: "uppercase",
              }}
            >
              — Stay Briefed —
            </div>
            <h2
              style={{
                fontFamily: "'Libre Baskerville', serif",
                fontSize: "48px",
                fontWeight: 700,
                fontStyle: "italic",
                color: "#f5ede0",
                lineHeight: 1.35,
                margin: 0,
              }}
            >
              Never Miss A Chapter
            </h2>
            <div
              style={{
                transform: `scale(${pulseScale})`,
                background: "#8b6914",
                borderRadius: "2px",
                padding: "16px 36px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "'Libre Baskerville', serif",
                  fontWeight: 700,
                  fontSize: "22px",
                  color: "#f5ede0",
                  letterSpacing: "2px",
                }}
              >
                🔔 Follow the Column
              </span>
            </div>
            <div
              style={{
                fontFamily: "'Special Elite', cursive",
                fontStyle: "italic",
                fontSize: "20px",
                color: "rgba(245,237,224,0.7)",
              }}
            >
              {keywords?.[1] || "@TheDigitalBullet"}
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
